module.exports = __webpack_public_path__ + "static/media/asenso-logo.a1af487a.png";